import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ContractHelperService {
  private mode: ContractModes = ContractModes.Default;

  constructor() {}

  setSuspendedMode(): void {
    this.mode = ContractModes.Suspended;
  }

  resetToDefaultMode(): void {
    this.mode = ContractModes.Default;
  }

  setReportsMode(): void {
    this.mode = ContractModes.Reports;
  }

  setRenewalMode(): void {
    this.mode = ContractModes.Renewal;
  }

  setAttritionMode(): void {
    this.mode = ContractModes.Attrition;
  }

  isSuspendedMode(): boolean {
    return this.mode === ContractModes.Suspended;
  }

  isDefaultMode(): boolean {
    return this.mode === ContractModes.Default;
  }

  isRenewalMode(): boolean {
    return this.mode === ContractModes.Renewal;
  }

  isAttritionMode(): boolean {
    return this.mode === ContractModes.Attrition;
  }

  isReportsMode(): boolean {
    return this.mode === ContractModes.Reports;
  }
}

enum ContractModes {
  Default = 1,
  Suspended = 2,
  Renewal = 3,
  Attrition = 4,
  Reports = 5,
}
